"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactComponents = require("@ui-propulsion/react-components");
var _default = function _default(props) {
  var makeCustomStyles = (0, _reactComponents.makeStylesPropulsion)(function (theme) {
    var typography = theme.typography,
      palette = theme.palette;
    var pxToRem = typography.pxToRem;
    return {
      chatBotButton: {
        border: '0',
        padding: '0',
        position: 'fixed',
        bottom: pxToRem(40),
        right: pxToRem(20),
        borderRadius: '50%',
        boxShadow: "0 ".concat(pxToRem(2), " ").concat(pxToRem(5), " rgba(0, 0, 0, 0.26)"),
        zIndex: '9998',
        cursor: 'pointer',
        transformOrigin: 'bottom',
        opacity: '1',
        transform: 'scale(1)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        animation: '$animation-show-up 0.4s cubic-bezier(0.62, 0.28, 0.23, 0.99)',
        animationDelay: '0.2s',
        animationFillMode: 'both',
        width: pxToRem(64),
        height: pxToRem(64),
        backgroundColor: function backgroundColor(_ref) {
          var _backgroundColor = _ref.backgroundColor;
          return _backgroundColor || '#65758e';
        },
        color: palette.common.white
      },
      '@keyframes animation-show-up': {
        '0%': {
          opacity: '0',
          transform: 'scale(0)'
        },
        '100%': {
          opacity: '1',
          transform: 'scale(1)'
        }
      }
    };
  }, {
    name: 'ChatBot'
  });
  return makeCustomStyles(props);
};
exports.default = _default;
